"use client";

import React from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function SearchBar() {
  const router = useNavigate();
  const [query, setQuery] = React.useState<string | any>(null);
  const [loading, setLoading] = React.useState(false);
  const doSearch = () => {
    if (!query) {
      alert("Type in your query");
      return;
    }
    setLoading(true);
    window.location.href = `/search/q/${encodeURIComponent(query)}`;
    //router(`/search/q/${encodeURIComponent(query)}`,{replace: true});
  };
  return (
    <React.Fragment>
      <div className="flex flex-col align-items-center justify-content-center">
        <div className="search-input-cover">
          <input
            type="search"
            name="query"
            disabled={loading}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={loading ? "Searching..." : "Search Products"}
          />
          {query && query.length > 0 && (
            <button title="Search" type="button" onClick={doSearch}>
             {loading ? "..." : <FaSearch />}
            </button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
